import React, {useCallback, useContext, useMemo, useState} from "react";
import {ConfigProvider, message} from "antd";
import {DynamicForm} from "../../components/DynamicForm.jsx";
import {NOOP} from "../../utils/NOOP.jsx";
import {HttpClient} from "../../http/HttpClient.jsx";
import {set} from "lodash";
import {AppContext} from "../../AppContext.jsx";
import {StringBuilder} from "../../AppUtils.js";

export const RemoveUserForm = () => {
    const {me} = useContext(AppContext);
    const [userInfo, setUserInfo] = useState({});

    const onUpdateForm = useCallback((_allValues, changedField) => {
        const [fieldKey, fieldValue] = Object.entries(changedField)[0];
        setUserInfo(currentValues => set({...currentValues}, fieldKey, fieldValue));
    }, []);

    const onFormSubmit = useCallback(async formValues => {
        const {error} = await HttpClient.safePost("/admin/api/user/removeUser", {email: formValues.email});

        if (error) {
            message.error(new StringBuilder().append("שגיאה בעת מחיקת משתמש").append(`(${error})`).toString());
            return;
        }

        message.success("הפעולה בוצעה בהצלחה");
    }, []);

    const FormFields = useMemo(
        () => [
            {
                className: "admin-user-management-input-email",
                name: "email",
                type: "email",
                label: "אימייל"
            }
        ],
        []
    );

    return (
        <ConfigProvider direction="rtl">
            <DynamicForm
                validationFunction={async values => {
                    if (me?.position !== "PRODUCT") {
                        message.error("אינך בעל הרשאות לבצע פעולה זאת");
                        return false;
                    }

                    await onFormSubmit(values);
                    return false;
                }}
                onSave={NOOP}
                content={userInfo}
                onUpdate={onUpdateForm}
                fields={FormFields}
            />
        </ConfigProvider>
    );
};
